import styled from 'styled-components';
import { PropertyCardPhotoWrapperMixin } from '../../mixins/components/PropertyCardPhotoWrapperMixin';
export var StyledPropertyCardPhotoWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledPropertyCardPhotoWrapper",
  componentId: "c11n-8-111-1__sc-1gbptz1-0"
})(["", ""], PropertyCardPhotoWrapperMixin);